module.exports = __webpack_public_path__ + "static/media/Corona-Hinweis-Kl1.1fdb64b9.jpg";